<template functional>
  <!-- <span v-if="$options.formatDate(props.row[props.column])">
      <i class="el-icon-time"></i>
      {{ $options.formatDate(props.row[props.column]) }}
    </span> -->

  <a
    v-if="props.month > 0"
    href="#"
    @click="$options.Selected(props)"
    :style="{ color: $options.getColor(props) }"
  >
    {{ $options.MothValue(props) }}
  </a>
  <span v-else>{{ $options.MothValue(props) }}</span>
</template>

<script>
import { formatMonto } from "../../utils";

export default {
  name: "DatetimeFormatter",
  Selected(props) {
    const { month } = props;
    const { VendorCode } = props.row;
    const type = props.getType();
    var a = `${props.column}${type !== "Cantidad" ? "Amount" : ""}`;
    const MothValue = Number(props.row[a]);

    if (MothValue <= 0) {
      return;
    }
    //console.log("HYPER LINK BROKEN -->",props);
    props.OpenSelection(month, VendorCode, props.row.ExecutiveName, props.row);
  },
  MothValue(props) {
    /*const prueba = props.row.PeddingInvoices;
    for(let i = 0; i<= pruebas; i++){
        console.log(i);
    }*/
    const type = props.getType();
    var a = `${props.column}${type !== "Cantidad" ? "Amount" : ""}`;
    if (type === "Monto") {
      if (Number(props.row[a]) > 0) {
        return formatMonto(props.row[a]);
      } else {
        return "";
      }
    } else {
      if (Number(props.row[a]) > 0) {
        return Number(props.row[a]);
      } else {
        return "";
      }
    }
  },
  getColor(props) {
    const { month } = props;
    const JanuaryPromiseDateNull = props.row.JanuaryPromiseDateNull;
    const FebruaryPromiseDateNull = props.row.FebruaryPromiseDateNull;
    const MarchPromiseDateNull = props.row.MarchPromiseDateNull;
    const AprilPromiseDateNull = props.row.AprilPromiseDateNull;
    const MayPromiseDateNull = props.row.MayPromiseDateNull;
    const JunePromiseDateNull = props.row.JunePromiseDateNull;
    const JulyPromiseDateNull = props.row.JulyPromiseDateNull;
    const AugustPromiseDateNull = props.row.AugustPromiseDateNull;
    const SeptemberPromiseDateNull = props.row.SeptemberPromiseDateNull;
    const OctoberPromiseDateNull = props.row.OctoberPromiseDateNull;
    const NovemberPromiseDateNull = props.row.NovemberPromiseDateNull;
    const DecemberPromiseDateNull = props.row.DecemberPromiseDateNull;

    if (JanuaryPromiseDateNull > 0 && month == 1) {
      return "red";
    }

    if (FebruaryPromiseDateNull > 0 && month == 2) {
      return "red";
    }
    if (MarchPromiseDateNull > 0 && month == 3) {
      return "red";
    }
    if (AprilPromiseDateNull > 0 && month == 4) {
      return "red";
    }
    if (MayPromiseDateNull > 0 && month == 5) {
      return "red";
    }
    if (JunePromiseDateNull > 0 && month == 6) {
      return "red";
    }
    if (JulyPromiseDateNull > 0 && month == 7) {
      return "red";
    }
    if (AugustPromiseDateNull > 0 && month == 8) {
      return "red";
    }
    if (SeptemberPromiseDateNull > 0 && month == 9) {
      return "red";
    }
    if (OctoberPromiseDateNull > 0 && month == 10) {
      return "red";
    }
    if (NovemberPromiseDateNull > 0 && month == 11) {
      return "red";
    }
    if (DecemberPromiseDateNull > 0 && month == 12) {
      return "red";
    }
    return "";
  }
};
</script>

<style>
.Negro {
  color: #606266;
}
.red {
  color: rgba(255, 0, 0, 0.712);
}
</style>
